export const GLOBAL_LABELS = 'global';

export const lblHeaderHelloText = 'lbl_header_helloText';

const AccountLabels = {
  global: {
    header: {
      [lblHeaderHelloText]: 'Hello',
    },
  },
  account: {
    common: {
      lbl_common_updateCTA: 'Update',
      lbl_common_cancelCTA: 'Cancel',
      lbl_common_backLink: 'Back',
      lbl_common_makeDefault: 'Make Default',
      lbl_common_edit: 'Edit',
      lbl_common_delete: 'Delete',
      lbl_common_successMessage: 'Your account has been updated',
      lbl_common_dontDelete: "No, Don't Delete",
      lbl_common_YesDelete: 'Yes, Delete',
      lbl_common_cancelCTACaps: 'CANCEL',
      lbl_common_addCTA: 'ADD NEW CARD',
      lbl_common_updateAddressCTA: 'UPDATE',
      lbl_common_tnc: 'Terms & Conditions',
      ACC_LBL_CANCEL_CTA_CAPS: 'CANCEL',
      lbl_common_current_points: 'Current Points',
      lbl_common_next_reward: 'Points to next reward',
      lbl_common_currency: '$',
      lbl_common_heading: 'My Rewards',
      lbl_common_details: 'Details',
      lbl_common_applied_to_order: 'APPLIED TO ORDER',
      lbl_common_order_date: 'ORDER DATE',
      lbl_common_transaction: 'TRANSACTION',
      lbl_common_points_earned: 'POINTS EARNED',
      lbl_common_points_history: 'Points History',
      lbl_common_next_reward_points: 'Points to Next Reward',
      lbl_common_point_balance: 'Points Balance',
      lbl_common_saveCTA: 'SAVE',
      lbl_common_tapClose: 'Tap to close it',
      lbl_common_couponTypeReward: 'REWARD',
      lbl_common_couponTypeSaving: 'SAVINGS',
      lbl_coupon_expiringSoon: 'EXPIRING SOON',
      lbl_coupon_detailsLink: 'Details',
      lbl_coupon_viewPrint: 'VIEW & PRINT',
      lbl_coupon_removeFromBag: 'REMOVE FROM BAG',
      lbl_coupon_applyToBag: 'APPLY TO BAG',
      lbl_coupon_expiring: 'EXPIRING',
      lbl_common_applied_to_bag: 'Applied to Bag',
      lbl_common_points_history_nopoints:
        "Looks like you don't have any points yet... Shop now to start earning points (and get rewards)!",
      lbl_common_viewAll: 'View All',
      lbl_common_earnExtraPoints: 'Earn Extra Points',
      lbl_common_points_history_heading: 'POINTS HISTORY',
      lbl_common_myFavoriteStore: 'My Favorite Store',
      lbl_common_addAStore: 'Add A Store',
      lbl_common_updateFavoriteStore: 'Update Favorite Store',
      lbl_common_accessBuyOnline:
        'Add your favorite store for easier shopping and access to Buy Online Pick Up In Store info, store hours and directions.',
      lbl_common_favStoreNotAdded: "You haven't added a favorite store yet.",
      lbl_points_history_program_details: 'Program Details',
      lbl_common_extraPointsHeading: 'EARN EXTRA POINTS',
      lbl_common_check_here: '*Click Here ',
      lbl_common_extra_points_terms_conditions: 'for Earn Extra Points Terms & Conditions',
      lbl_extraExtraPoints_more_points: 'Earn even more points by activating these offers!',
      lbl_earnExtraPoints_getReward: 'Get even closer to your next reward. ',
      lbl_coupon_seeRedeemDates: 'SEE REDEEM DATES',
      lbl_changePassword_shopNow: 'SHOP NOW',
      lbl_purchaseGiftsCard_animatedGiftCards: 'Animated Gift Cards',
      lbl_purchaseGiftsCard_eGiftCard: 'eGift Card',
      lbl_purchaseGiftsCard_physicalGiftCard: 'Physical Gift Card',
      lbl_purchaseGiftsCard_physicalGiftCardPageTitle: 'GIFT CARDS',
      lbl_purchaseGiftsCard_pageTitle: 'GIFT CARDS',
      lbl_giftCardBalanceLoading: 'LOADING...',
      lbl_bia_sub_title: 'Save time & shop your previously-purchased styles.',
      lbl_bia_no_products_found_msg:
        'Once you’ve made an order, you’ll be able to shop previously-purchased styles.',
      lbl_rnr_main_title: 'Rate & Review',
      lbl_rnr_review_your_products: 'Review Your Products',
      lbl_rnr_thank_you_note: 'Thank you #name for your valuable review!',
      lbl_rnr_previously_reviwed_products: 'Previously Reviewed Products',
      lbl_rnr_your_review: 'Your Review',
      lbl_rnr_product_to_review: 'Products to be Reviewed',
      lbl_rnr_product_reviewed: 'Products Reviewed',
      lbl_rnr_pending_reviewed: 'Pending Review',
      lbl_rnr_summary_title: 'Overview',
      lbl_rnr_review_modal_heading: 'Review Your Previous Purchases',
      lbl_beacon_notification_greeting_text:
        'Enhance your shopping experience with In-Store Mode on our app',
      lbl_beacon_notification_title: 'Welcome to',
      lbl_rnr_review_submit_success:
        'Thank you! We are processing your review, this may take a few days.',
      lbl_rnr_review_submitted: 'Review Submitted',
      lbl_rnr_modal_header: 'Rate & Review Your Purchases',
      lbl_rnr_tap_to_rate: 'tap to rate',
      lbl_order_history_product_unavailable_header: 'Sorry! This item is no longer available.',
      lbl_order_history_product_back_cta: 'GO BACK',
      lbl_common_address: 'Address',
    },
  },
};
export default AccountLabels;
